import React from "react";
import { FormContext } from "./form-context";
import { getInputValue } from "../utils";

const field = Component =>
  function FieldComponent(props) {
    return (
      <FormContext.Consumer>
        {context => {
          const { name, onChange, isOverridingValueUpdates, ...rest } =
            props || {};
          const { form } = context || {};

          let defaultValue = form?.getValue(name);
          if (name?.includes(".")) {
            const [parentKey, childKey] = name.split(".");
            const parentValue = form?.getValue(parentKey);
            defaultValue = parentValue?.[childKey];
          }

          const errors = form?.errors[name] || [];
          const handleUpdate = (e, obj) => {
            form?.onChange(e);
            form?.updateValue(obj);
          };

          const handleChange = (e, minMax) => {
            const { target } = e || {};
            const value = getInputValue(target, minMax);

            if (name.includes(".")) {
              const [parentKey, childKey] = name.split(".");
              handleUpdate(e, {
                [parentKey]: {
                  ...form?.getValue(parentKey),
                  [childKey]: value
                }
              });
            } else {
              handleUpdate(e, { [name]: value });
            }
          };

          const componentProps = {
            ...rest,
            name,
            defaultValue,
            errors,
            onChange: isOverridingValueUpdates
              ? (e, minMax) => {
                  onChange(
                    e,
                    name,
                    getInputValue(e.target, minMax),
                    handleUpdate
                  );
                }
              : handleChange
          };

          return <Component {...componentProps} />;
        }}
      </FormContext.Consumer>
    );
  };

export default field;
